import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import {
  ModificationRequestDeliverableForDetailFragment,
  ModificationRequestForDetailFragment,
} from '../../../../generated/graphql';
import { toJSDate } from '../../../../graphql/datetime';
import { SPACING_REGULAR } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import _Item from './Item';

interface Props {
  modificationRequest: ModificationRequestForDetailFragment;
  deliverables: Array<ModificationRequestDeliverableForDetailFragment>;
  className?: string;
}

const ModificationRequestDeliverables = ({
  modificationRequest,
  deliverables,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const modificationRequestDeliverables = deliverables.map((deliverable, i) => (
    <Item deliverable={deliverable} key={`modificationRequestDeliverables-${i}`} />
  ));

  return (
    <div className={className}>
      <Items>{modificationRequestDeliverables}</Items>
      {modificationRequest.state === 'approved' ? (
        <Titles>
          <Title variant="subtitle1">
            {modificationRequest.approvedAt ? (
              <FormattedDate
                value={toJSDate(modificationRequest.approvedAt)}
                year="numeric"
                month="2-digit"
                day="2-digit"
                hour="2-digit"
                minute="2-digit"
              />
            ) : null}
          </Title>
          <Title variant="subtitle1">
            <FormattedMessage id="show_creation_page.modification_request_approved" />
          </Title>
        </Titles>
      ) : null}
    </div>
  );
};

const Items = styled('div')(flexibleLayoutContainer({ direction: 'column' }));

const Item = styled(_Item)({
  marginBottom: SPACING_REGULAR,
  ':last-child': {
    marginBottom: 0,
  },
});

const Titles = styled('div')({
  marginBottom: SPACING_REGULAR,
});

const Title = styled(Typography)({});

export default ModificationRequestDeliverables;
